import React from "react";
import cn from "classnames";
import styles from "./Row.module.sass";
import moment from "moment/moment";
import { useNavigate } from "react-router-dom";


const Row = ({ item, activeTable, activeId, }) => {
  const navigate = useNavigate();

  const handleRowClick = () => {
    navigate(`/settingsDashboard/Cameras/${item.id}`); 
  };

  return (
    <div
      className={cn(
        styles.row,
        { [styles.selected]: activeId === item.id },
        { [styles.active]: activeTable }
      )}
      onClick={handleRowClick}
    >
      <div className={styles.col}>
        <div className={styles.email}>{item.name}</div>
      </div>
      <div className={styles.col}>
        <div className={styles.email}>{item.brand}</div>
      </div>
      <div className={styles.col}>
        <div className={styles.email}>
          {moment(item.created_at).format("DD MMM YYYY")}
        </div>
      </div>
    </div>
  );
};

export default Row;